/**
 * Created by Allan on 2021/11/04.
 * Contact 84880528@qq.com.
 */
/*****
 * 处理 http 成功状态
 * @param  axios response 对象
 * @return 成功状态下返回data 数据，如果包含错误信息，则将后台返回的完整的错误信息 reject 出去。{code:'401', message:'这是一个错误', errors:[] }.
 * *****/
import router from '@/baseloan/router/'
import { Dialog } from 'vant'
const successHandler = response =>{
    var code = response.data.code;
    if(code==='000000'){
        //从respons header获取最新token并跟印象
        let token = response.headers['authorization'];
        //success
        return Promise.resolve(response.data);
    }else if(code ==='401401'){
        Dialog.alert({
            title:'提示',
            message:'您还未登录或登录信息失效，请重新登录！',
        }).then(() => {
            let urlParams=JSON.parse(localStorage.getItem('urlParams'));
            let indexParams=`?a=${urlParams.appId}&b=${urlParams.userId}&c=${urlParams.genderName}&d=${urlParams.utmSource}`
            router.push(`/index${indexParams}`)
            //localStorage.removeItem('userInfo');
            //localStorage.removeItem('bankCardList');
            //localStorage.clear();
            window.location.reload();
            return false
        });
    }
    return Promise.reject(response.data);
};
/*****
 * 处理http 失败状态
 * @param  axios error ,处理不同错误时的错误消息，确保返回出去为统一的格式。方便处理
 * @return 将完整的错误信息 reject 出去 {code:'401', message:'这是一个错误', errors:[] }
 * *****/
const errHandler = (error) => {
    console.error(`%c接口请求失败 ==>${error.response?error.response.config.url:''}\n`,"color:red",error.response || error);
    // 浏览器返回的错误在 error.response 里面获取，服务器返回的提示信息 直接包含在 error 里面。
    if (error.code) {
        if(error.code==='404'){
            return Promise.reject({code:404,message:'数据接口不存在，请联系管理员！'})
        }
        return Promise.reject(error);
    }
    return Promise.reject(error);

};

export  { successHandler, errHandler };



// WEBPACK FOOTER //
// ./src/baseloan/service/http/config.js